'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var TOGGLE_SHOWING_PAGE_TITLE_NOTIFICATION = exports.TOGGLE_SHOWING_PAGE_TITLE_NOTIFICATION = 'TOGGLE_SHOWING_PAGE_TITLE_NOTIFICATION';


//////////////////
// WEBPACK FOOTER
// ./js/page-title-notifications/constants/pageTitleNotificationsActionTypes.js
// module id = 618
// module chunks = 2 3